import NotSyncedIcon from 'react-icons/lib/go/primitive-dot';
import { StyledCloseIcon } from '../Tab/elements';

export const StyledNotSyncedIcon = StyledCloseIcon.withComponent(NotSyncedIcon);
